/* eslint-disable @typescript-eslint/no-explicit-any */
import type { JSX, ReactNode } from 'react';

import { getIn } from 'formik';
import styled from 'styled-components';

import Control from '../Control';
import { ErrorIcon, ErrorValidation } from '../ErrorValidation';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

interface RequiredGroupField {
  field: string;
  label?: string;
  type?: string;
  validations?: any;
  onChecked?: any;
  onChange?: any;
  onBlur?: any;
  onAddTag?: any;
  additionalProps?: {
    placeholder?: string;
    [key: string]: any;
  };
}

interface FieldRequiredGroupProps {
  formik: any;
  name: string;
  requiredGroupFields: RequiredGroupField[];
  subtitle?: ReactNode;
}

function FieldRequiredGroup({
  formik,
  name,
  requiredGroupFields,
  subtitle
}: FieldRequiredGroupProps): JSX.Element {
  // Get error message if exists
  const errorMessage = getIn(formik.form.errors, name);

  // Ignore nested object errors
  const hasError =
    errorMessage !== undefined &&
    !(errorMessage instanceof Object);

  const controls = requiredGroupFields.map(item => {
    const key = `${name}.${item.field}`;

    const props = {
      name: key,
      label: item.label,
      placeholder: item.additionalProps?.placeholder,
      type: item.type,
      validations: item.validations,
      hasGroupError: hasError,
      onChecked: item.onChecked,
      onChange: item.onChange,
      onBlur: item.onBlur,
      onAddTag: item.onAddTag
    };

    return <Control key={key} {...props} />;
  });

  return (
    <Wrapper>
      {subtitle}
      {controls}

      {hasError && (
        <ErrorValidation>
          <ErrorIcon />
          <p>{errorMessage}</p>
        </ErrorValidation>
      )}
    </Wrapper>
  );
}

export default FieldRequiredGroup;